import styled from 'styled-components';

import IconPlus from 'components/icons/plus';

const PlusIcon = styled(IconPlus)`
  width: 10px;
  display: inline-block;
  margin: auto;
  fill: ${Styles.color.primary};
`;

export default PlusIcon;
